<template>
  <!-- modal cadastro -->
  <b-modal id="modal-editar-criadores" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Editar Criadores</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-editar-criadores')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <template class="modal-body">
      <form>
        <h6><i class="fas fa-user-tag"></i> Editar criadores:</h6>
        <div class="row">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <label for="coordenador">
                Coordenador
                <div class="d-flex align-items-center float-right">
                    Alterar Coordenador
                      <div class="custom-control custom-switch status-curso-switch">
                        <b-form-checkbox v-model="alteraCoordenador" name="check-button" switch>
                        </b-form-checkbox>
                      </div>
                </div>
              </label>
              <form-group id="coordenador" label="" :text="{ required: 'Obrigatório informar o coordenador' }" :field="$v.coordenador">
                <select class="form-control" v-model="coordenador">
                  <option v-if="professores.length == 0" value="">Carregando...</option>
                  <option :disabled="!alteraCoordenador" v-if="professores.length > 0" value="" >Selecione</option>
                  <option :disabled="!alteraCoordenador" v-for="professor in professores" :key="professor.id" :value="professor.id">{{ professor.professor }}</option>
                </select>
              </form-group>
            </div>
          </div>

          <div class="col-12 col-md-12">
            <div class="form-group">
              <label for="professor">
                Professor
                <div class="d-flex align-items-center float-right">
                    Alterar Professor
                    <div class="custom-control custom-switch status-curso-switch">
                      <b-form-checkbox v-model="alteraProfessor" name="check-button" switch>
                      </b-form-checkbox>
                    </div>
                </div>
              </label>
              <form-group id="professor" label="" :text="{ required: 'Obrigatório informar o professor' }" :field="$v.professor">
                <select class="form-control" v-model="professor">
                  <option v-if="professores.length == 0" value="">Carregando...</option>
                  <option :disabled="!alteraProfessor" v-if="professores.length > 0" value="">Selecione</option>
                  <option :disabled="!alteraProfessor" v-for="professor in professores" :key="professor.id" :value="professor.id">{{ professor.professor }}</option>
                </select>
              </form-group>
            </div>
          </div>

        </div>

        <div class="text-center">
          <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
            <button class="btn btn-primary mr-3" type="button" @click="editarCriadores" >Editar </button>
            <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-editar-criadores')">Cancelar</a>
          </div>
        </div>
      </form>
    </template>
  </b-modal>
</template>

<script>
// import VideoAPI from '@/api/video-api'
// import Swal from 'sweetalert2'
// import ResponseUtils from '@/core/util/response-utils'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'

export default {
  name: 'modalEditarCriadores',
  components: { FormGroup },
  props: {
    videosSelecionadas: Array,
    professores: Array,
    cursos: Array,
    modulos: Array,
    licoes: Array
  },
  data () {
    return {
      ordemVideo: '',
      alteraCoordenador: true,
      alteraProfessor: true,
      coordenador: '',
      professor: ''
    }
  },

  computed: {
    videosInput: function () {
      let retorno = []
      this.videosSelecionadas.map(video => {
        retorno.push({
          id: video.id
        })
      })
      return retorno
    }
  },

  watch: {
    alteraCoordenador (value) {
      if (!value) {
        this.coordenador = ''
      }
    },
    alteraProfessor (value) {
      if (!value) {
        this.professor = ''
      }
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.professor = ''
      this.coordenador = ''
    })
  },

  validations: {
    professor: { required },
    coordenador: { required }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-editar-criadores')
    },

    editarCriadores: function () {
      let valido = true
      if (this.alteraCoordenador) {
        this.$v.coordenador.$touch()
        if (this.$v.coordenador.$invalid) {
          valido = false
        }
      }
      if (this.alteraProfessor) {
        this.$v.professor.$touch()
        if (this.$v.professor.$invalid) {
          valido = false
        }
      }

      if (valido) {
        this.$emit('editarCriadores', this.coordenador, this.professor)
        this.$bvModal.hide('modal-editar-criadores')
      }
    }
  }
}
</script>
